
import { defineComponent, onMounted, PropType, ref } from 'vue'
import { IFormItem } from '../types/index'
export default defineComponent({
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    formItems: {
      //设置传递的值为IFormItem所规范的类型
      type: Array as PropType<IFormItem[]>,
      default: () => []
    },
    //自定义form宽度
    labelWidth: {
      type: String,
      default: () => '100px'
    },
    //自定义el-item的padding
    itemStyle: {
      type: Object,
      default: () => ({ padding: '10px 40px' })
    },
    //根据el-col属性来响应式布局
    colLayout: {
      type: Object,
      default: () => ({
        xl: 6,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      })
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    /* modelValue更新时触发,使得父组件数据更新 */
    const handleValueChange = (value: any, field: string) => {
      emit('update:modelValue', { ...props.modelValue, [field]: value })
    }
    return {
      handleValueChange
    }
  },
  components: {}
})
